export default `
mutation cancelOrder($input:cancelOrderInput!) { 
    cancelOrder(input:$input){ 
        order{
            order_id
        }
    }
}
`;
